import React from 'react';
import { Link } from 'react-router-dom';
/** const **/
import { CONTACT_FORM_URL } from 'const';
/** styles,images **/
import s from '../../styles/common/footer.module.scss';
import InstagramLogo from 'assets/images/instagram.webp';
import MecLogo from 'assets/images/mec-logo.webp';

export const Footer: React.FC = () => {
  return (
    <footer className={s.footer}>
      <div className={s.titleWrap}>
        <p className={s.projectName}>ペットライフサポート プロジェクト</p>
        <p className={s.note}>本件は事業化検討段階のため内容が変更となる場合があります</p>
      </div>
      <div className={s.menuRow}>
        <nav className={s.menu}>
          <Link to="/">TOPページ</Link>
          <span>｜</span>
          <Link to="/news-list">お知らせ</Link>
          <span>｜</span>
          <Link to="/worries">ペットとペットオーナーの悩み</Link>
          <span>｜</span>
          <Link to="/about">真の“ペットと人の共生”マンションとは</Link>
          <span>｜</span>
          <Link to="/p-man-comic">皆さまの4コマ劇場</Link>
          <span>｜</span>
          <Link to="/supporters-voice">SUPPORTER’S VOICE＆PHOTO</Link>
          <span>｜</span>
          <Link to="/faq">FAQ</Link>
          <span>｜</span>
          <a href="https://www.mec.co.jp/privacy/" target="_blank" rel="noreferrer">
            Privacy Policy
          </a>
          <span>｜</span>
          <Link to="/terms">利用規約</Link>
          <span>｜</span>
          <a href={CONTACT_FORM_URL} target="_blank" rel="noreferrer">
            お問い合わせ
          </a>
        </nav>
        <a className={s.instaLink} href="https://www.instagram.com/petlifesupport.mec/" target="_blank" rel="noreferrer">
          <img src={InstagramLogo} alt="Instagram" />
          FOLLOW US
        </a>
      </div>
      <div className={s.copyrightRow}>
        <div className={s.mecWrapper}>
          <a className={s.mecLogo} href="https://www.mec.co.jp/" target="_blank" rel="noreferrer">
            <img src={MecLogo} alt="三菱地所" />
          </a>
          <p>
            これまで、オフィスや住宅、ホテルなどの開発・運営を通じ、数多くの快適な空間と憩いの時間を提供してきた三菱地所が新たに手掛けるサービスです。
          </p>
        </div>
        <p className={s.copyright}>COPYRIGHT © MITSUBISHI ESTATE CO., LTD. ALL RIGHTS RESERVED.</p>
      </div>
    </footer>
  );
};
